import { render, staticRenderFns } from "./sign-success-notify.vue?vue&type=template&id=204ac724&scoped=true&"
import script from "./sign-success-notify.vue?vue&type=script&lang=js&"
export * from "./sign-success-notify.vue?vue&type=script&lang=js&"
import style0 from "./sign-success-notify.vue?vue&type=style&index=0&id=204ac724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ac724",
  null
  
)

export default component.exports